import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { cloneDeep, map } from 'lodash';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { LinkTypeMode } from '../../../types';
import { utils } from '../../../services';
/**
 * 图文广告位，广告填充项组件列表
 */
export class EntryList extends PureComponent<{
    maxCount?: number;
    onChange?: (value: any) => void;
    onDragStart?: (result: any) => void;
    onDragEnd?: (result: any) => void;
    value?: Array<any>;
    data: any;
    renderItem: any;
    renderTips: any;
    linkTypes: Array<any>;
    linkTypeMode?: LinkTypeMode;
    showModule?: boolean;
}> {
    static propTypes = {
        maxCount: PropTypes.number,
        onChange: PropTypes.func,
        value: PropTypes.array,
        data: PropTypes.object,
    };

    state = { uploadLoading: false };

    componentDidMount() {
        const { value, onChange, showModule } = this.props;
        if (!value.length && !!showModule) {
            onChange([...value, { uuid: utils.uuid() }]);
        }
    }

    onDragStart = (result: any) => {
        const { onDragStart } = this.props;
        onDragStart && onDragStart(result);
    };

    onDragEnd = (result: any) => {
        if (!result.destination) {
            return;
        }
        const { value, onChange, onDragEnd } = this.props;
        let newValue = cloneDeep(value);
        const startIndex = result.source.index;
        const endIndex = result.destination.index;
        const [removed] = newValue.splice(startIndex, 1);
        newValue.splice(endIndex, 0, removed);
        onDragEnd && onDragEnd(result);
        onChange(cloneDeep(newValue));
    };

    renderItem = (item: any, index: any, isDragDisabled: any) => {
        const { renderItem, onChange, linkTypes, linkTypeMode, value, data } = this.props;
        const itemContent = React.createElement(renderItem, {
            linkTypes,
            linkTypeMode,
            index,
            item,
            items: value,
            data,
            onChange,
        });
        return (
            <Draggable
                key={`${item.uuid || index}`}
                isDragDisabled={isDragDisabled}
                draggableId={'drag-' + `${item.uuid || index}`}
                index={index}
            >
                {(provided: any) => {
                    return (
                        <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                        >
                            {itemContent}
                        </div>
                    );
                }}
            </Draggable>
        );
    };

    renderCreateItem = () => {
        const { value, maxCount, renderTips, onChange } = this.props;
        if (value.length >= maxCount) {
            return undefined;
        }
        const tipsContent = React.createElement(renderTips, { items: value, onChange });
        return tipsContent;
    };

    renderItems = () => {
        let { value: items } = this.props;
        const isDragDropDisabled = items.length === 1;
        return (
            <DragDropContext onDragStart={this.onDragStart} onDragEnd={this.onDragEnd}>
                <Droppable
                    isDropDisabled={isDragDropDisabled}
                    droppableId="cm-editor-list"
                    direction="vertical"
                >
                    {(provided: any) => (
                        <div ref={provided.innerRef} {...provided.droppableProps}>
                            {map(items, (item, index) => {
                                return this.renderItem(item, index, isDragDropDisabled);
                            })}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        );
    };

    render() {
        return (
            <div className="entry-list">
                {this.renderItems()}
                {this.renderCreateItem()}
            </div>
        );
    }
}
